import { action, makeObservable, observable, remove, set, values } from 'mobx';
export class FilterStore {
    constructor() {
        Object.defineProperty(this, "filters", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {}
        });
        makeObservable(this, {
            filters: observable,
            setFilter: action,
            removeFilter: action,
            setFieldFilter: action,
            removeFieldFilter: action,
            reset: action,
        });
    }
    filter(objects) {
        const filterFunctions = values(this.filters);
        // Exit early if no filtering has to be done
        if (filterFunctions.length === 0) {
            return objects;
        }
        return objects.filter((object) => !filterFunctions.some((filter) => !filter(object)));
    }
    setFilter(name, filter) {
        set(this.filters, name, filter);
    }
    removeFilter(name) {
        remove(this.filters, name);
    }
    setFieldFilter(field, value) {
        const { name, filter } = this.getFieldValueFilter(field, value);
        this.setFilter(name, filter);
    }
    removeFieldFilter(field) {
        const name = this.getFieldValueFilterName(field);
        this.removeFilter(name);
    }
    getFieldValueFilter(field, value) {
        return {
            name: this.getFieldValueFilterName(field),
            filter: ((object) => object[field] === value),
        };
    }
    getFieldValueFilterName(field) {
        return `field-value-filter-${String(field)}`;
    }
    reset() {
        Object.keys(this.filters).forEach((filterName) => {
            remove(this.filters, filterName);
        });
    }
}
//# sourceMappingURL=FilterStore.js.map